import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import store from 'store';
import Box from 'ui-box';
import { Typography, Button, Divider, Space } from 'antd';
import HomeMenuList from '../../../components/mobile/HomeMenuList';
import { ReactComponent as AccountIconSvg } from '../../../assets/icons/user-account/personal-information.svg';
import { ReactComponent as DoctorSvg } from '../../../assets/icons/speak-doctor/doctor.svg';
import { MENTAL_HEALTH_QUESTION_TAG_APPOINTMENT } from '../../../config/constants';

const { Title } = Typography;

const styles = {
  title: {
    fontWeight: "400",
    fontSize: "18px",
    lineHeight: "26px",
    textAlign: "center",
    letterSpacing: "0.02em",
    color: "#404047"
  },
  divider: {
    fontSize: 15,
    fontWeight: 400,
    color: '#404047',
    margin: 0
  },
  selectOption: {
    fontWeight: "300",
    fontSize: "15px",
    lineHeight: "20px",
    textAlign: "center",
    letterSpacing: "0.02em",
    color: "#15A9E1"
  }
}

function MobileSpeakDoctorScreen() {
  const { t } = useTranslation(['speak-doctor', 'common']);
  const [selectedNextPath, setSelectedNextPath] = useState(null)
  const history = useHistory();

  const menu = [
    {
      id: 1,
      icon: <AccountIconSvg />,
      title: t('speak-doctor:home.menu.covid'),
      url: '/speak-doctor/covid',
      tag: 'COVID-19'
    },
    {
      id: 2,
      icon: <AccountIconSvg />,
      title: t('speak-doctor:home.menu.mentalHealth'),
      url: '/speak-doctor/mental-health-questions',
      tag: 'Mental Health'
    },
    {
      id: 3,
      icon: <AccountIconSvg />,
      title: t('speak-doctor:home.menu.pregnancy'),
      url: '/speak-doctor/pregnancy',
      tag: 'Maternal Health'
    },
    {
      id: 4,
      icon: <AccountIconSvg />,
      title: t('speak-doctor:home.menu.nutrition'),
      url: '/speak-doctor/nutrition',
      tag: 'Nutrition'
    }
  ]

  const onChange = (value) => {
    const find = menu.find(x => x.url === value)
    setSelectedNextPath(value)
    if (find)
      store.set(MENTAL_HEALTH_QUESTION_TAG_APPOINTMENT, find.tag)
  }

  const onNext = () => {
    if (selectedNextPath !== null) {
      history.push(selectedNextPath);
    }
  }

  const submitRequest = () => {
    history.push('/speak-doctor/submit-response')
  }

  return (
    <>
      <Box display="flex" justifyContent="center">
        <DoctorSvg style={{ margin: '20', maxWidth: '80%' }} />
      </Box>
      <Box textAlign="center">
        <Title level={4} style={styles.title}>
          {t('speak-doctor:home.title')}
        </Title>
        <Title level={4} style={styles.selectOption}>
          {t('speak-doctor:home.selectOption')}
        </Title>
      </Box>
      <Box style={{ padding: 0, marginTop: 24 }}>
        {menu.map(({icon, title, url}) => (
          <HomeMenuList icon={icon} title={title} isSelected={url === selectedNextPath} onClick={() => onChange(url)} />
        ))}
      </Box>
      <Box style={{ padding: 0 }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Button
            htmlType="button"
            type="primary"
            size="large"
            onClick={onNext}
            block
          >
            {t('common:button.next')}
          </Button>
          <Divider plain><p style={styles.divider}>{t('speak-doctor:home.somethingElse')}</p></Divider>
          <Button
            htmlType="button"
            type="primary"
            size="large"
            onClick={submitRequest}
            block
            ghost
          >
            {t('common:button.submitRequest')}
          </Button>
        </Space>
      </Box>
    </>
  );
}

export default MobileSpeakDoctorScreen;
